module.exports = __webpack_public_path__ + "static/media/unamused-emoji-svgrepo-com.b16b87fe.svg";